'use strict';

var angular = require('angular');
var _ = require('lodash');
var LogDecorator = function LogDecorator($delegate, $window, logService) {
  var debug = false;
  var console = $window.console;
  var levels = ['debug', 'info', 'warn', 'error'];
  function formatError(obj) {
    if (obj instanceof Error) {
      if (obj.stack) {
        obj = obj.message && obj.stack.indexOf(obj.message) === -1 ? 'Error: ' + obj.message + '\n' + obj.stack : obj.stack;
      } else if (obj.sourceURL) {
        obj = obj.message + '\n' + obj.sourceURL + ':' + obj.line;
      }
    }
    return obj;
  }
  function decorate(level) {
    function decorated() {
      if (level !== 'debug' || debug) {
        var args = Array.prototype.slice.apply(arguments);
        var formattedArgs = _.map(args, formatError);
        var logger = console[level] || console.log;
        logger.apply(logger, formattedArgs);
        logService.logMessage({
          level: _.toUpper(level),
          message: formattedArgs
        });
      }
    }
    decorated.logs = [];
    return decorated;
  }
  _.forEach(levels, function (level) {
    $delegate[level] = decorate(level);
  });
  $delegate.metric = function (key, value, eventSubtype) {
    if (debug) {
      console.log(key + ': ' + Math.round(value));
    }
    logService.logMetric({
      key: key,
      value: value,
      eventSubtype: eventSubtype
    });
  };
  $delegate.timing = function (key, value) {
    if (debug) {
      console.log(key + ': ' + Math.round(value) + ' ms');
    }
    logService.logTiming({
      key: key,
      value: value
    });
  };
  $delegate.debugEnabled = function (value) {
    if (angular.isDefined(value)) {
      debug = value;
    }
    return debug;
  };
  return $delegate;
};
LogDecorator.$inject = ['$delegate', '$window', 'LogService'];
module.exports = LogDecorator;